import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScHavePromocode = styled.div`
  display: flex;
  padding: 32px 24px;
  flex-direction: column;
  background-color: ${({ theme }) => theme.grayLightColor};
  gap: 32px;
  border-radius: 16px;

  .header {
    display: flex;
    flex-direction: column;
    gap: 16px;
    text-align: center;
    line-height: 28px;

    & > .title {
      font-size: 22px;
      line-height: 28px;
      letter-spacing: 0.44px;
      text-transform: uppercase;
      font-weight: 700;
    }

    & > .description {
      color: ${({ theme }) => theme.gray1Color};
      font-size: 16px;
      letter-spacing: 0.16px;

      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const ScPromocodeFormWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;

  form {
    width: 100%;
  }

  .join-btn {
    width: 260px;
  }

  .bonuses-notice-box {
    width: min(600px, 100%);
    margin-inline: auto;

    &:empty {
      display: none;
      margin: 0;
    }
  }

  & .error strong {
    cursor: pointer;
    text-decoration: underline;
    transition: opacity 0.2s ease-in-out;

    @media (hover: hover) {
      &:hover {
        opacity: 0.6;
      }
    }
  }

  @media (${device.mobileS}) {
    flex-direction: column;
  }
`;
